import type { NotifyPort } from '@/features/messages/domain/notify'
import type { UpdateWorkItemInput, WorkItem, WorkItemPort } from '../domain/workflow'

const updateWorkItem = async (
	port: WorkItemPort,
	input: UpdateWorkItemInput,
	notify: NotifyPort,
): Promise<WorkItem | null> => {
	try {
		const updated = await port.update(input)
		notify.success('workItem.updated')
		return updated
	} catch {
		notify.error('workItem.updateFailed')
		return null
	}
}

export { updateWorkItem }
